export default "__VITE_ASSET__CkWfpjZn__"